module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('default-layout', [_c('div', {
    staticClass: "h-full flex flex-col max-w-screen-3xl px-5 py-3"
  }, [_c('div', {
    staticClass: "flex items-center mb-4 space-x-3"
  }, [_c('div', {
    staticClass: "text-2xl font-bold font-poppins text-gray-800"
  }, [_vm._v("My Profile")])]), _vm._v(" "), _c('div', {
    staticClass: "bg-white rounded h-full flex-grow border border-solid border-gray-200"
  }, [_c('div', {
    staticClass: "flex border-b border-coolGray-200 h-10"
  }, _vm._l((_vm.displayableTabs), function(selectedTab, index) {
    return _c('button', {
      key: index,
      staticClass: "text-sm text-gray-500 cursor-pointer border-0 px-4",
      class: _vm.isSelectedTab(selectedTab.routeName) ? ['text-primary border-solid	border-b mt-0.5 border-primary'] : [],
      on: {
        "click": function($event) {
          return _vm.goToTab(selectedTab.routeName)
        }
      }
    }, [_vm._v("\n          " + _vm._s(selectedTab.title) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-body px-6 py-6"
  }, [_c('transition', [(_vm.getProfile.loading) ? _c('div', [_c('div', {
    staticClass: "flex justify-center items-center mb-2"
  }, [_c('pl-spinner')], 1)]) : _c('router-view')], 1)], 1)])]), _vm._v(" "), (_vm.enableModal2FA) ? _c('Enable2FAModal', {
    attrs: {
      "type2FA": _vm.type2fa
    },
    on: {
      "close": function($event) {
        _vm.enableModal2FA = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4e1cda6d!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/profile/profile.vue
// module id = 1637
// module chunks = 61